const COUNT_SEQUENCE_PAD = 4;

/** Número de conteo para mostrar: `formatInventoryCountNumber(5)` → `#0005`. Zero-pad a 4 dígitos. */
export function formatInventoryCountNumber(sequenceId: number): string {
  return `#${sequenceId.toString().padStart(COUNT_SEQUENCE_PAD, '0')}`;
}
